import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetLatAndLonRequest, LatAndLonResponse, MapSliceModel } from "shared/interfaces/map-interfaces";
import { ErrorResponse, RejectedValue } from "shared/interfaces/core-interfaces";

export const GetLatAndLon = createAsyncThunk<LatAndLonResponse[], GetLatAndLonRequest, { rejectValue: RejectedValue }>(
    'Slice/MapSlice/GetLatAndLon',
    async (req: GetLatAndLonRequest, { rejectWithValue }) => {

        const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&country=${req.country}&state=${req.state}&postalcode=${req.postalCode}&city=${req.city}&street=${req.street}`, {
            method: "GET",
        });
        if (response.status === 200) {
            const responseModel = await response.json() as LatAndLonResponse[];
            return responseModel;
        }
        else {
            const errorResponse = await response.json() as ErrorResponse;
            return rejectWithValue({ message: errorResponse.detail, status: errorResponse.status });
        }
    }
);

const initialValue: MapSliceModel = {
    statusCode: '',
    isLoading: false,
    isModalLoading: false,
    message: '',
    showNotification: false,
    coordinates: { lat: 0, lon: 0 }
}

export const MapSlice = createSlice({
    name: 'MapSlice',
    initialState: initialValue,
    reducers: {
        resetMapSlice: (state) => {
            state.statusCode = '';
            state.isLoading = false;
            state.isModalLoading = false;
            state.message = '';
            state.showNotification = false;
            state.coordinates.lat = 0;
            state.coordinates.lon = 0;
        },
        resetCoordinates: (state) => {
            state.coordinates.lat = 0;
            state.coordinates.lon = 0;
        },
        resetStatusCode: (state) => {
            state.statusCode = '';
            state.message = '';
            state.showNotification = false;
        },
    },
    extraReducers(builder) {
        //GetLatAndLon
        builder
            .addCase(GetLatAndLon.fulfilled, (state, action: PayloadAction<LatAndLonResponse[]>) => {
                state.isLoading = false;
                state.message = '';
                if (action.payload.length > 0) {
                    state.coordinates.lat = action.payload[0].lat;
                    state.coordinates.lon = action.payload[0].lon;
                    state.showNotification = false;
                }
                else {
                    state.coordinates.lat = 0;
                    state.coordinates.lon = 0;
                    state.message = 'We were unable to locate the address you provided. Please double-check the address.';
                    state.showNotification = true;
                }
            })
            .addCase(GetLatAndLon.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload?.message ?? 'Error in application';
                state.showNotification = true;
                state.statusCode = action.payload?.status?.toString() ?? 'Code is not valid';
            })
            .addCase(GetLatAndLon.pending, state => {
                state.isLoading = true;
            })
    }
})

export const { resetMapSlice, resetCoordinates, resetStatusCode } = MapSlice.actions;
export default MapSlice.reducer;